import { WarningAmber } from "@mui/icons-material"
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles,
  useMediaQuery,
} from "@material-ui/core"
import { themePalette } from "./styles"

const useStyles = makeStyles((theme) => ({
  titleRow: {
    display: "flex",
    alignItems: "center",
    gap: "0.55rem",
  },
  titleIcon: {
    color: theme.palette.warning.main,
    fontSize: "1.2rem",
    flexShrink: 0,
  },
  cancelButton: {
    textTransform: "uppercase",
    transition: theme.transitions.create(["background-color", "border-color", "box-shadow", "color"], {
      duration: theme.transitions.duration.short,
    }),
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
      borderColor: theme.palette.primary.main,
      boxShadow: "none",
    },
  },
  confirmButton: (props) => ({
    backgroundColor: props.confirmColor,
    color: theme.palette.common.white,
    textTransform: "uppercase",
    boxShadow: "none",
    transition: theme.transitions.create(["background-color", "border-color", "box-shadow", "color"], {
      duration: theme.transitions.duration.short,
    }),
    "&:hover": {
      backgroundColor: props.confirmColor === theme.palette.error.main
        ? theme.palette.error.dark
        : theme.palette.primary.dark,
      boxShadow: "none",
    },
  }),
}))

// Modal generico de confirmacion para acciones sensibles de la pantalla.
// Vale la pena mantenerlo separado porque el copy cambia, pero la estructura visual es siempre la misma.
export default function ModalAffirm({
  open,
  title,
  description,
  confirmLabel = "Aceptar",
  cancelLabel = "Cancelar",
  confirmColor = themePalette.primary.main,
  onConfirm,
  onClose,
}) {
  const classes = useStyles({ confirmColor })

  // Adapta el modal a pantalla completa en mobile.
  const isMobile = useMediaQuery("(max-width:900px)")

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      fullScreen={isMobile}
      PaperProps={{
        style: {
          borderRadius: isMobile ? 0 : "0.3rem",
          border: isMobile ? "none" : `1px solid ${themePalette.border.main}`,
          boxShadow: themePalette.shadow.dialog,
        },
      }}
    >
      {/* Titulo principal de la confirmacion. */}
      <DialogTitle
        style={{
          padding: isMobile ? "1rem" : "1rem 1.1rem 0.65rem",
          fontSize: "0.98rem",
          fontWeight: 700,
          color: themePalette.text.title,
        }}
      >
        <span className={classes.titleRow}>
          {/* Refuerza visualmente que la accion requiere atencion. */}
          <WarningAmber className={classes.titleIcon} />
          <span>{title}</span>
        </span>
      </DialogTitle>

      {/* Texto descriptivo con el impacto de la accion. */}
      <DialogContent style={{ padding: isMobile ? "0 1rem 1rem" : "0 1.1rem 1rem" }}>
        <Box style={{ fontSize: "0.92rem", lineHeight: 1.55, color: themePalette.text.secondary }}>
          {description}
        </Box>
      </DialogContent>

      {/* Acciones para cancelar o confirmar la operacion. */}
      <DialogActions
        style={{
          padding: isMobile ? "0 1rem 1rem" : "0 1.1rem 1rem",
          gap: "0.65rem",
          justifyContent: "center",
        }}
      >
        {/* Cancela la operacion y cierra el modal. */}
        <Button
          onClick={onClose}
          variant="outlined"
          className={classes.cancelButton}
          style={{
            minWidth: isMobile ? "calc(50% - 0.35rem)" : "140px",
            minHeight: "36px",
            borderRadius: "0.25rem",
            borderColor: themePalette.border.dialog,
            color: themePalette.text.secondary,
            textTransform: "uppercase",
            fontWeight: 600,
            fontSize: "0.78rem",
          }}
        >
          {cancelLabel}
        </Button>
        {/* Confirma la accion elegida por el usuario. */}
        <Button
          onClick={onConfirm}
          color="primary"
          variant="contained"
          className={classes.confirmButton}
          style={{
            minWidth: isMobile ? "calc(50% - 0.35rem)" : "180px",
            minHeight: "36px",
            borderRadius: "0.25rem",
            fontWeight: 700,
            fontSize: "0.78rem",
          }}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
